module.exports = __webpack_public_path__ + "static/media/logoblanco-canimolt_footer.8cbc62b9.png";